export default __webpack_public_path__ + "static/app-1abc6b18314d8b92e7573837f7f4cd6b.png";